<template>

  <div>
    <header-sales></header-sales>
    <div id="subheader"> </div>

    <div id="main-container">
      <div id="label-container">
        <span id="label">Ver Pedido</span>
      </div>
      <div id= "container">

        <div id= "header-pedido">

          <div id= "header-pedidoL">
            <span class="label-total" v-show='false' >Pedido &nbsp;</span>
            <img id="icon" class="menu" src="/dist/icon-editar.png" v-show='false'/>
          </div>

          <div >
            <div class="label-total">Subtotal: $ {{subtotal | formatMoney}} </div>
            <div class="label-total">Total: $ {{total | formatMoney}} </div>
          </div>

        </div>

          <div id="list-container">
            <item-pedido id="list-prod" v-for="item in productos" :item='item' ></item-pedido>
          </div>
          <div id="btnContainer">
            <input id="btnReplicar" @click="btnReplicar" type="submit" value="REPLICAR  PEDIDO">
          </div>

      </div>
    </div>
  </div>

</template>


  <script>
    import axios from 'axios'
    import HeaderSales from '@components/views/header.vue';
    import ItemPedido from '@components/views/estadoPedido/itemPedidoCms.vue';


    export default {
      name: 'Pedido',
      components:{
       'header-sales': HeaderSales,
       'item-pedido': ItemPedido,
      },


      data() {
         return {
           productos:[],
           replicaPedido:[],
           pedido:null,
         }
      },


      computed: {
        numeroPedido(){
          if (this.pedido != null)
          {
            return this.pedido.Numero
          }
          else
          {
            return 0
          }
        },

        fechaPedido(){
          if (this.pedido != null)
          {
            return this.pedido.Fecha
          }
          else
          {
            return ''
          }
        },

        items () {
          return this.$store.state.pedido.carrito;
        },

        subtotal () {
          var st= 0.0;
          this.productos.forEach((element) => {
            st = st + element.Precio * element.Cantidad;
          });
          return st;
        },
        total () {
          return this.pedido ? this.pedido.MontoTotal : 0.0
        }


      },


    methods: {

      getPedido: function () {
        this.$store.commit('loader/start')
        var url = '/WebSalesPedidosListado?PedidoId='+String(this.$store.state.pedido.pedidoId);
        axios.get(url,{
          headers:{
                    Token:this.$store.state.user.token,
                    ClientSecret: process.env.CLIENT_SECRET,
                    EmpresaId: process.env.EMPRESA_ID
                  }
        }).then((response) => {
            this.$store.commit('loader/stop')
          if (response.data.Code == 0)
           {
             console.log(response.data)
             this.pedido = response.data
             this.productos = response.data.Productos
           }
           else if (response.data.Code == 99)
           {
             alert(response.data.Message)
             this.$router.push({name: 'login'});
           }
           else
           {
             console.log(">>>>"+response.data.Message);
             alert(response.data.Message);
           }
        },(error) => {
           console.log(error)
           alert(error);
        })

      },

      btnReplicar() {
        if (this.$store.state.pedido.carrito.length > 0)
        {
          var obj = {
                      txt:'Existe un nuevo pedido en curso, si replica el pedido actual los ítems cargados en el nuevo pedido se perderán.',
                      txtBtnCancel:'Cancelar',
                      txtBtnOk:'Replicar',
                      fCancel:null,
                      fOk:this.replicarPedido
                    }
          this.$store.commit('popup/open',obj);
        }
        else
        {
          this.replicarPedido();
        }
      },

      replicarPedido() {
        this.$store.commit('pedido/eliminarPedido');

        // replica productos
        this.productos.forEach((e) => {
          var producto = this.$store.state.pedido.productos.find( elem => elem.Id === e.ProductoId)
          if (producto != null)
          {
            var nuevoProducto = {
              id: producto.Id,
              idCategoria: producto.CategoriaId,
              idSubcategoria: producto.SubCategoriaId,
              producto:producto.Nombre,
              descripcion:producto.Nombre,
              precio:producto.Precio,
              cantidad: e.Cantidad,
              peso:producto.EnvasePeso,
              archivoId:producto.ArchivoId,
              promocionId:0,
              tipoOblea:1
              }
            this.replicaPedido.push(nuevoProducto);
          }
        })

        // replica promociones
        this.productos.forEach((e) => {
          var promocion = this.$store.state.pedido.promociones.find( elem => elem.Id === e.PromocionId)
          if (promocion != null)
          {
            var imagen = ''
            if (promocion.ArchivosId != null  && promocion.ArchivosId >= 1)
            {
              imagen = promocion.ArchivosId[0]
            }

            var nuevoProducto = {
              id: 0,
              idCategoria: 0,
              idSubcategoria: 0,
              producto:promocion.Nombre,
              descripcion:promocion.Nombre,
              precio:promocion.PrecioPromocional,
              cantidad: e.Cantidad,
              peso:promocion.Peso,
              archivoId:imagen,
              promocionId:promocion.Id,
              tipoOblea:1
              }
            this.replicaPedido.push(nuevoProducto);
          }
        })

        this.$store.commit('pedido/replicarPedido',this.replicaPedido);
        this.$router.push({name: 'pedido'});
      }

    },

    mounted: function () {
      this.$store.commit('loader/stop')
      this.getPedido();
    }

  }


  </script>


  <style scoped>

  .boton:hover { cursor: pointer; }
  #btnClose:hover { cursor: pointer; }



  .fadePro-enter {
    opacity: 0;
  }
  .fadePro-enter-active {
    transition: opacity 0.5s;
  }
  .fadePro-enter-to {
    opacity: 1;
  }
  .fadePro-leave {
    opacity: 1;
  }
  .fadePro-leave-active {
    transition: opacity 0.1s;
  }
  .fadePro-leave-to {
    opacity: 0;
  }


  /*----------------------------*/

   #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
   }


 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }



#header-pedido{
 width: 700px;
 height: 65px;
 display: flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
}

#header-pedidoL{
 width: 260px;
 height: 100%;
 display: flex;
 flex-direction: row;
 background: #ffffff;
 justify-content: flex-start;
 align-items: center;
}

#header-pedidoR{
 width: 370px;
 height: 100%;
 display: flex;
 flex-direction: row;
 background: #ffffff;
 justify-content: flex-end;
 align-items: center;
}




 #label-container{
  width: 700px;
  height: 10vh;

 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }

  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column;
   align-items: center;
  }

  #list-container{
   width: 660px;
   height: 61vh;
   background: #ffffff;
   overflow: auto;
   display: flex;
   flex-direction:column;
   align-items: center;
   }


 #total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}

.label2{
  font-size: 14px;
  color:#5D6770;
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}


  #btnReplicar{
    width: 120px;
    height: 30px;
    font-size: 9px;
    border-style: solid;
    border:none;
    background: #44C7F4;
    border-radius: 20px;
    color: #ffffff;
  }



  input[type="submit"]:hover
  {
    cursor: pointer;
  }


/* width */
  ::-webkit-scrollbar {
      width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd;
      border-radius: 10px;
  }


  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb;
      border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
  }


  ::-webkit-scrollbar {
  display: block; }


  </style>



// WEBPACK FOOTER //
// src/components/views/estadoPedido/pedidoCms.vue